var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lawful-interception-guide"},[_c('div',{class:{ markmapbox: true }},[_c('svg',{attrs:{"id":"markmapsvg"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }